import React, { Component } from 'react';
import { Jumbotron, Container, Row, Button, ButtonGroup } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { GET_PENDING_PREMIUM_GIFS, GET_ACCEPTED_PREMIUM_GIFS, GET_MOST_USED_GIF, GET_TAGS } from '../../query/query';
import { ACCEPT_ALL_GIFS } from '../../mutation/mutation';
import Gif from './gif';
import './gif.css';

const SORT_BY = Object.freeze({
  RANK: 'rank',
  DESIGNER_RANK: 'designerRank',
});

class PremiumModeratorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gifs: [],
      acceptedGifs: [],
      mostUsedGif: {},
      display: true,
      tags: [],
      sortBy: SORT_BY.RANK,
    };
    this.setSortBy = this.setSortBy.bind(this);
  }

  setSortBy(sortBy) {
    this.setState({ sortBy });
    this.sortGifs(sortBy);
  }

  sortGifs(sortBy) {
    if (!sortBy) {
      sortBy = this.state.sortBy;
    }
    const { gifs, acceptedGifs } = this.state;
    this.setState({
      acceptedGifs: acceptedGifs.sort((gif1, gif2) => gif2[sortBy] - gif1[sortBy]),
      gifs: gifs.sort((gif1, gif2) => gif2[sortBy] - gif1[sortBy]),
    });
  }

  getPendingPremiumGifs() {
    this.props.client.query({
      query: GET_PENDING_PREMIUM_GIFS,
    }).then(({ data }) => {
      if (data.savPendingPremiumGifs) {
        this.setState({
          gifs: data.savPendingPremiumGifs,
        });
        this.sortGifs();
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  getAcceptedPremiumGifs() {
    this.props.client.query({
      query: GET_ACCEPTED_PREMIUM_GIFS,
    }).then(({ data }) => {
      if (data.savAcceptedPremiumGifs) {
        this.setState({
          acceptedGifs: data.savAcceptedPremiumGifs,
        });
        this.sortGifs();
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  getTags() {
    this.props.client.query({
      query: GET_TAGS,
    }).then(({ data }) => {
      if (data.tags) {
        this.setState({
          tags: data.tags,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  getMostUsedGif() {
    this.props.client.query({
      query: GET_MOST_USED_GIF,
    }).then(({ data }) => {
      if (data.savMostUsedGif) {
        this.setState({
          mostUsedGif: data.savMostUsedGif,
        });
      }
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  componentWillMount() {
    this.getPendingPremiumGifs();
    this.getAcceptedPremiumGifs();
    this.getTags();
  }

  acceptAllGifs() {
    const confirm = window.confirm('⚠️ Make all gifs public? They will be available for everyone.');
    if (!confirm) {
      return;
    }
    this.props.client.mutate({
      mutation: ACCEPT_ALL_GIFS,
    }).then(({ data }) => {
      if (data || data.savAcceptAllGifs) {
        this.setState({ display: false });
      }
    }).catch((err) => {
      console.log('catch', err);
      if (err.message.includes('401')) {
        alert('You are not allowed to do this.');
      }
    });
  }

  changeHandler(gif) {
    this.setState({ acceptedGifs: this.state.acceptedGifs.concat(gif) });
  }

  render() {
    const { sortBy } = this.state;
    return (
      <Jumbotron>
        <h3 className="display-4">
          Gifs
        </h3>
        <h5>Sort by</h5>
        <ButtonGroup>
          <Button
            color="primary"
            onClick={() => this.setSortBy(SORT_BY.RANK)}
            active={sortBy === SORT_BY.RANK}
          >
              Rank
          </Button>
          <Button
            color="primary"
            onClick={() => this.setSortBy(SORT_BY.DESIGNER_RANK)}
            active={sortBy === SORT_BY.DESIGNER_RANK}
          >
              Designer rank
          </Button>
        </ButtonGroup>
        <hr className="my-2" />
        <h4>Most used gif this month</h4>
        <Button
          onClick={() => {
            this.getMostUsedGif();
          }}
          color="success">
          Display mot used gif this month
        </Button>
        <br />
        Please use this button only if necessary
        { (Object.keys(this.state.mostUsedGif).length !== 0) && (
          <Container className={this.state.display ? '' : 'd-none'}>
            <Row>
              <h5>{this.state.mostUsedGif.name}</h5>
            </Row>
            <Row>
              <img
                className="pixelated"
                src={this.state.mostUsedGif.base64}
                alt="gif"
                style={{ height: 64, width: 128 }}
              />
              {
                this.state.mostUsedGif.base64Outlined && (
                  <img
                    style={{ backgroundColor: '#8A64FF', height: 64, width: 128 }}
                    src={this.state.mostUsedGif.base64Outlined}
                    alt="gif"
                  />
                )
              }
            </Row>
          </Container>
        )}
        <hr className="my-2" />
        <Button
          onClick={() => {
            this.acceptAllGifs();
          }}
          color="success">
          Accepter tous les gifs
        </Button>
        &nbsp;
        <a href="#accepted-gif">Vers les gifs acceptés</a>
        <hr className="my-2" />
        <h4>Gifs en attente</h4>
        <hr className="my-2" />
        <Container className={this.state.display ? '' : 'd-none'}>
          {
            this.state.gifs.map(s => <Gif key={s._id} gif={s} client={this.props.client} onChange={this.changeHandler.bind(this)} tags={this.state.tags} />)
          }
        </Container>
        <hr className="my-2" />
        <h4 id="accepted-gif">Gifs acceptés</h4>
        <hr className="my-2" />
        <Container className={this.state.display ? '' : 'd-none'}>
          {
            ([].concat(this.state.acceptedGifs))
              .map(s => <Gif key={s._id} gif={s} client={this.props.client} hideButtons={true} tags={this.state.tags} />)
          }
        </Container>
      </Jumbotron>
    );
  }
}

export default withApollo(PremiumModeratorPage);



// WEBPACK FOOTER //
// ./src/components/premium_moderator/moderator.js